const environment = {
    endpoint: 'https://rnr-eko-dev-staging.ekoapp.com',
    giphyApiKey: 'Kt2pXXkCz6IITSwSNncHW33vE1O4Jk4u',
};
export default environment;
//# sourceMappingURL=env.js.map